import { ComponentPropsWithoutRef, ElementType, ReactNode } from 'react';
import classNames from 'classnames';
import styles from './Section.module.scss';

interface _SectionProps<T extends ElementType> {
  containerClassName?: string;
  children: ReactNode;
  className?: string;
  as?: T;
}

export type SectionProps<T extends ElementType> =
  | ComponentPropsWithoutRef<T>
  | _SectionProps<T>;

function Section<T extends ElementType = 'section'>({
  as: Component = 'section',
  containerClassName,
  className,
  children,
  ...props
}: SectionProps<T>) {
  return (
    <Component {...props} className={containerClassName}>
      <div className={classNames(styles.content, className)}>{children}</div>
    </Component>
  );
}

export default Section;
